<template>
  <v-container>
    <v-snackbar
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <base-material-card
          v-if="!loading"
          color="primary"
          icon="mdi-bank"
          inline
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Billing Rates Management
            </div>
          </template>
          <v-col cols="12">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            />
          </v-col>
          <v-row>
            <v-col
              sm="12"
            >
              <v-card
                class="pa-2"
                outlined
                tile
              >
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-dialog v-model="dialog">
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                            >
                              <v-text-field
                                v-model="editedItem.idnum"
                                label="Site Name"
                                disabled
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                            >
                              <v-text-field
                                v-model="editedItem.address"
                                label="Address"
                                disabled
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                            >
                              <v-text-field
                                v-model="editedItem.city"
                                label="City"
                                disabled
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                            >
                              <v-select
                                v-model="editedItem.state"
                                :items="getstates"
                                disabled
                                label="State"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                            >
                              <v-text-field
                                v-model="editedItem.zipcode"
                                label="Zipcode"
                                disabled
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                            >
                              <v-text-field
                                v-model="editedItem.sitecontactnumber"
                                label="Contact Number"
                                disabled
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="6"
                            >
                              <v-text-field
                                v-model="editedItem.sitecontactname"
                                label="Contact Name"
                                disabled
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                            >
                              <v-autocomplete
                                v-model="editedItem.billingclientkey"
                                :items="getbillingclients"
                                item-text="name"
                                item-value="key"
                                label="Billing Client"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                            >
                              <v-autocomplete
                                v-model="editedItem.creditprovider"
                                :items="creditprovider"
                                label="Credit Provider"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="4"
                            >
                              <v-autocomplete
                                v-model="editedItem.billingprofilekey"
                                :items="getbillingprofiles"
                                item-text="name"
                                item-value="key"
                                label="Billing Profile"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          @click="close"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          :disabled="!formIsValid"
                          @click="save"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-spacer />
                </v-toolbar>
                <v-data-table
                  :headers="headers"
                  :search="search"
                  :items="currentmachines"
                  item-key="idnum"
                  class="elevation-1"
                  :single-expand="singleExpand"
                  :expanded.sync="expanded"
                >
                  <template
                    v-if="userallowed"
                    v-slot:[`item.billingclient`]="{ item }"
                  >
                    <div v-if="item.billingclientkey">
                      {{ billingclientdetail(item) }}
                    </div>
                    <div v-else>
                      PLEASE SET
                    </div>
                  </template>
                  <template
                    v-if="userallowed"
                    v-slot:[`item.billingprofilekey`]="{ item }"
                  >
                    <div v-if="item.billingprofilekey">
                      {{ billingclientdetail(item) }}
                    </div>
                    <div v-else>
                      PLEASE SET
                    </div>
                  </template>
                  <template
                    v-if="userallowed"
                    v-slot:[`item.billingprofile`]="{ item }"
                  >
                    <div v-if="item.billingprofilekey">
                      {{ billingprofiledetail(item) }}
                    </div>
                    <div v-else>
                      PLEASE SET
                    </div>
                  </template>
                  <template
                    v-if="userallowed"
                    v-slot:[`item.action`]="{ item }"
                  >
                    <v-icon

                      color="primary"
                      size="20"
                      @click="editItem(item)"
                    >
                      mdi-square-edit-outline
                    </v-icon>
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary">
                      Reset
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </base-material-card>

        <v-spacer />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // Components

  export default {
    data: () => ({
      search: '',
      dialog: false,
      time: null,
      newgroup: '',
      snackbar: false,
      syncChange: false,
      changeProvider: ['Safe and Sound'],
      singleExpand: true,
      expanded: [],
      timeout: 5000,
      alertmessage: '',
      currentgroups: '',
      showchange: false,
      singleSelect: false,

      sitetype: ['physical', 'virtual', 'postal'],
      scheduletype: ['daily', 'weekly', 'biweekly', 'monthly'], // we calc iso week as some months shorter, some longer
      supportedTimezones: ['EST', 'CST', 'MST', 'PST', 'GMT'],
      locationTags: ['Restaurants', 'Retail', 'Parking', 'Car Wash', 'Other'],
      safeType: ['Single Note', 'Tray Fed', 'High Speed'],
      noteCapacity: ['600', '1000', '2000', '3000', '4000', '10000', '20000'],
      provCredit: false,
      creditprovider: ['DTSConnex', 'CashConnect', 'Signature', 'Dimebank', 'Paythings', 'Other', 'None'],
      creditproviderId: '',
      externalsafe: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      modal2: false,
      loading: false,
      headers: [
        { text: 'Site Name', value: 'idnum', align: 'left', width: 200 },
        { text: 'Group', value: 'group', align: 'left' },
        { text: 'Billing Client', value: 'billingclient', align: 'left', width: 200 },
        { text: 'Site Type', value: 'sitetype', align: 'center' },
        { text: 'Rate Profile', value: 'billingprofile', align: 'center' },
        { text: 'Actions', value: 'action', sortable: false }
      ],
      sites: [],
      editedIndex: -1,
      editedItem: {
        idnum: '',
        crypto_idnum: '',
        billingclientkey: '',
        billingprofilekey: '',
        creditProvider: '',
        monthlyrate: '',
        originalidnum: '',
        nightlyrestart: '',
        sitekey: '',
        sitetype: '',
        schedule: '',
        address: '',
        city: '',
        state: '',
        zipcode: '',
        group: '',
        changeSystemID: '',
        changeProvider: '',
        shipmentspermonth: '',
        allowedusers: null,
        changeorderprofiles: [],
        locationTags: null,
        safeType: 'none',
        noteCapacity: '',
        provCredit: false,
        creditprovider: '',
        creditproviderId: '',
        creditproviderLocationID: '',
        creditproviderapikey: '',
        wifipw: '',
        externalsafe: false,
        wifiaccess: '',
        country: '',
        sitecontactnumber: '',
        sitecontactname: '',
        supportemail: '',
        supportnumber: '',
        timezone: '',
        time_open: '',
        time_close: '',
        time_eod: '',
        time_deposit_summary: ''
      },
      defaultItem: {
        idnum: '',
        crypto_idnum: '',
        billingclientkey: '',
        billingprofilekey: '',
        creditProvider: '',
        monthlyrate: '',
        originalidnum: '',
        nightlyrestart: '',
        address: '',
        sitekey: '',
        sitetype: '',
        shipmentspermonth: '',
        schedule: '',
        city: '',
        state: '',
        zipcode: '',
        externalsafe: false,
        wifipw: '',
        wifiaccess: '',
        group: '',
        changeSystemID: '',
        changeProvider: '',
        allowedusers: [],
        changeorderprofiles: [],
        locationTags: [],
        safeType: '',
        noteCapacity: '',
        provCredit: false,
        creditprovider: '',
        creditproviderId: '',
        creditproviderLocationID: '',
        country: '',
        sitecontactnumber: '',
        sitecontactname: '',
        supportemail: '',
        supportnumber: '',
        timezone: '',
        time_open: '',
        time_close: '',
        time_eod: '',
        time_deposit_summary: ''
      }
    }),

    computed: {
      formIsValid () {
        return this.editedItem.billingclientkey !== '' &&
          this.editedItem.billingprofilekey !== ''
      },
      getbillingclients () {
        let clients = []
        clients = this.$store.getters.getbillingclients
        return clients
      },
      getbillingprofiles () {
        let profiles = []
        profiles = this.$store.getters.getLoadedBillingProfiles
        return profiles
      },
      getcurrentgroups () {
        this.$log.debug('groups', this.$store.getters.usergroups)
        this.currentgroups = this.$store.getters.usergroups
        return this.currentgroups
      },
      grouplist () {
        // return []
        let groups = this.$store.getters.usergroups.map(
          group => group.name
        )
        return groups
      },
      userallowed () {
        if (parseInt(this.$store.getters.user.level) >= 500 || this.$store.getters.user.status === 'corporate') {
          this.$log.debug('user allowed', this.$store.getters.user.level)

          return true
        }
        this.$log.debug('user NOT allowed', this.$store.getters.user.level)

        return false
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New Site' : 'Edit Site'
      },
      currentmachines () {
        this.sites = this.$store.getters.loadedSites
        // load only ones with a Postal_ type safe currently assigned to them
        let profiles = this.$store.getters.loadedSiteProfiles
        let billingconfigs = this.$store.getters.getbillingconfigs
        // loop thru the profiles
        // find any profile that contains postal
        let siterecords = Object.values(profiles)
        let site_profiles = []
        console.log('postal profiles ', siterecords)
        siterecords.forEach(entry => {
          if (entry.siteunitsprofile && entry.siteunitsprofile[0]) {
            if (entry.siteunitsprofile[0].crypto_idnum) {
              Object.assign(entry, { safeid: entry.siteunitsprofile[0].crypto_idnum })
            } else {
              Object.assign(entry, { safeid: 'unknown' })
            }

            site_profiles.push(entry)
          }
        })
        console.log('postal sites found ', site_profiles)
        let active_sites = []
        site_profiles.forEach(entry => {
          this.sites.forEach(site => {
            if (site.sitekey === entry.sitekey) {
              // get the key records and add them in this record here
              // we dont put them in the site records because the adapters listen for
              // changes to that record
              // get the config for that sitekey
              if (entry.safeid.includes('PostalSafe')) {
                Object.assign(site, { sitetype: 'PostalSafe' })
              }
              if (entry.safeid.includes('VirtualSafe')) {
                Object.assign(site, { sitetype: 'VirtualSafe' })
              }
              if (entry.safeid.includes('B1')) {
                Object.assign(site, { sitetype: 'SmartSafe MW' })
              }
              if (entry.safeid.includes('B2')) {
                Object.assign(site, { sitetype: 'SmartSafe MW' })
              }
              if (entry.safeid.includes('B3')) {
                Object.assign(site, { sitetype: 'SmartSafe MW' })
              }
              if (entry.safeid.includes('AMSEC')) {
                Object.assign(site, { sitetype: 'SmartSafe AMSEC' })
              }
              if (entry.safeid.includes('S&S-')) {
                Object.assign(site, { sitetype: 'SmartSafe PT' })
              }
              let config = billingconfigs.find(config => config.sitekey === entry.sitekey)
              if (config) {
                site.billingclientkey = config.billingclientkey
                site.billingprofilekey = config.billingprofilekey
              }
              console.log('billing configs ', billingconfigs, site)
              active_sites.push(site)
            }
          })
        })
        console.log('postal sites finally ', active_sites)
        return active_sites
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },
    created () {
      this.loading = true
      this.$store.dispatch('loadunits')
      this.$store.dispatch('loadsiteProfiles')
      this.$store.dispatch('loadSiteConfigs')
      this.$store.dispatch('loadUserProfiles')
      this.$store.dispatch('loadbillingclients')
      this.$store.dispatch('loadbillingprofiles')
      this.$store.dispatch('loadMachineBillingConfig')
      this.$log.debug('SITES LOADED: ', this.$store.getters.loadedSites)
      this.sites = this.$store.getters.loadedSites
      this.$log.debug('this sites is: ', this.sites)
      console.log(this.sites)
    },

    methods: {
      billingclientdetail (item) {
        let clients = []
        clients = this.$store.getters.getbillingclients
        let detail
        detail = clients.find(entry => entry.key === item.billingclientkey)
        return detail.name
      },
      billingprofiledetail (item) {
        let profiles = []
        profiles = this.$store.getters.getbillingprofiles
        let detail
        detail = profiles.find(entry => entry.key === item.billingprofilekey)
        console.log(detail)
        return detail.name
      },
      userlist (group) {
        this.$log.debug('%%%%% group passed is ', group)
        let people = this.$store.getters.userprofiles
        this.$log.debug('people rec is ', people)
        let usersfromgroup = people.filter(person => person.group === group)
        return usersfromgroup.map(usr => usr.email)
      },
      editItem (item) {
        this.editedIndex = this.sites.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        this.$log.debug('this is an edit')
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        this.$log.debug(' can we save this ? ', this.editedItem)

        console.log(' setting ', this.editedItem)
        const machineUpdateData = {
          sitekey: this.editedItem.sitekey,
          creditprovider: this.editedItem.creditprovider,
          billingclientkey: this.editedItem.billingclientkey,
          billingprofilekey: this.editedItem.billingprofilekey
        }
        if (this.editedIndex > -1) {
          console.log('we saved on edit here', machineUpdateData)
          this.$store.dispatch('updateMachineBillingConfig', machineUpdateData)

          this.$store.dispatch('loadunits')
          this.$store.dispatch('loadsiteProfiles')
          this.$store.dispatch('loadSiteConfigs')
          this.$store.dispatch('loadUserProfiles')
          this.$store.dispatch('loadMachineBillingConfig')
          this.$log.debug('SITES LOADED: ', this.$store.getters.loadedSites)
          this.sites = this.$store.getters.loadedSites
        } else {
          console.log('we dont create new sites here ')
          // this.$store.dispatch('createMachineConfig', machineData)
          this.sites.push(this.editedItem)
        }
        this.$store.dispatch('loadunits')
        this.$store.dispatch('loadsiteProfiles')
        this.$store.dispatch('loadSiteConfigs')
        this.$store.dispatch('loadUserProfiles')
        this.sites = this.$store.getters.loadedSites
        this.close()
      }
    }
  }
</script>
<style>
  .card--flex-toolbar {
    margin-top: -64px;
  }
</style>
